export const footerData = [
  {
    text: '会社概要',
    href: '/main/html/company',
  },
  {
    text: 'プライバシーポリシー',
    href: 'https://prtimes.co.jp/policy/',
  },
  {
    text: 'コンテンツ基準',
    href: 'https://tayori.com/faq/89b604344ebb744dbba41f73d4134560c997a743',
    isExternal: true,
  },
  {
    text: '利用規約',
    href: '/main/html/kiyaku',
    isExternal: true,
  },
  {
    text: '報道関係者様からのお問い合わせ',
    href: 'https://tayori.com/form/c5788940efb74672cc13bd2cb1d8587b3f20fcb8',
    isExternal: true,
  },
  {
    text: '企業様からのお問い合わせ',
    href: 'https://tayori.com/form/536e9f54c53fb0fa255e36237e66a8c50e2cd625',
    isExternal: true,
  },
  {
    text: '一般の皆様からのお問い合わせ',
    href: 'https://tayori.com/form/81416340de36e393af7b2d7e6e707112d77c06d4',
    isExternal: true,
  },
];
